<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md">
      <!-- Código + estado -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="font-weight-bold">&nbsp;</span>
        <div><span><b>Estado:</b></span>
          <span class="badge" :class="record.status === 1 ? 'badge-success' : 'badge-danger'">
          {{ record.status === 1 ? 'Activo' : 'Inactivo' }}
        </span>
        </div>

      </div>

      <!-- Curso / Módulo -->
      <div class="small text-muted mb-2">
        <i class="fas fa-book mr-1"></i>{{ record.coursename || '—' }}
        <span class="mx-1">›</span>
        <i class="fas fa-layer-group mr-1"></i>{{ record.modulename || '—' }}
      </div>
      <div><span class="field-label">Código&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> {{ record.code }}</div>
      <!-- <div><span><b>Curso:</b> {{ record.coursename }}</span></div>
      <div><span><b>Módulo:</b> {{ record.modulename }}</span></div> -->
      <br>
      <div><span class="field-label">Pregunta&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><div v-html="record.question"></div></div>
      <br>
      <div>
        <span class="field-label">Imagen de pregunta</span><br>
        <div v-if="record.url_image" class="text-center mb-2">
          <br>
          <img
          :src="record.url_image"
          alt="Imagen de la pregunta" width="50%"
          class="b-radius shadow"
        />
        </div>
        <div v-else><cite>Sin Imagen de pregunta</cite></div>
      </div>
      <br>
      <div class="border-top pt-2"><span class="field-label">Explicación&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><div v-if="record.explanation" v-html="record.explanation"></div><div v-else> Sin explicación</div></div>
      <!-- <div><span><b>Estado:</b> {{ record.status === 1 ? 'Activo' : 'Inactivo' }}</span></div> -->
      <!-- <div><span><b>Registrado:</b> {{ record.created }}</span></div>
      <div><span><b>Actualizado:</b> {{ record.updated }}</span></div> -->
      <br>
      <div>
        <span class="field-label">Imagen de explicación&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><br>
        <div v-if="record.url_explanation_img" class="text-center mb-2">
          <br>
          <img
          :src="record.url_explanation_img"
          alt="Imagen de explicación" width="50%"
          class="b-radius shadow"
        />
        </div>
        <div v-else><cite>Sin Imagen de explicación</cite></div>
      </div>
      <br>
      <div class="border-top pt-2"><span class="field-label">Respuestas&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></div>
      <div v-if="record.answers && record.answers.length">
        <div v-for="(answer, index) in record.answers" :key="answer.id">
          <input v-if="record.typeanswer_id == 1" type="radio" :checked="answer.selection == 1" disabled>
          <input v-else type="checkbox" :checked="answer.selection == 1" disabled>
          <span class="answer-text" v-html="answer.answer"></span>
        </div>
      </div>
      <div v-else>Sin respuestas registradas</div>
      <br>
      <!-- Fechas -->
      <div class="d-flex justify-content-between text-muted small border-top pt-2">
        <span><i class="fas fa-calendar-plus mr-1"></i> Creado: {{ record.created }}</span>
        <span><i class="fas fa-calendar-check mr-1"></i> Actualizado: {{ record.updated }}</span>
      </div>
      <br>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
      dataRecord: [],
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      // this.$emit('getRecords');
      // bvModalEvent.preventDefault()
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>

<style scoped>
.field-label {
  display: inline-block;
  font-weight: 700;
  color: inherit;
  border-bottom: 3px solid #05B6B9;
  text-decoration: none;
  padding-bottom: 2px;
  margin-bottom: 4px;
}
.answer-text ::v-deep p {
  display: inline;
  margin: 0;
}
.field-label::before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  background: #404E67;
  border-radius: 50%;
  margin-right: 7px;
  vertical-align: middle;
}
</style>